var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "workflow-archival-basic" }, [
    _c(
      "header",
      [
        _c(
          "flex-grid",
          [
            _c(
              "flex-grid-item",
              { attrs: { grow: "1" } },
              [
                _c("text-input", {
                  attrs: {
                    label: "Query",
                    name: "queryString",
                    type: "search",
                    value: _vm.queryString
                  },
                  on: { input: _vm.onTextChange }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "flex-grid-item",
              { attrs: { width: "85px" } },
              [
                _c("button-fill", {
                  attrs: {
                    label: "BASIC",
                    tag: "router-link",
                    to: {
                      name: "workflow-archival-basic",
                      params: { clusterName: _vm.clusterName }
                    }
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "section",
      { staticClass: "results" },
      [
        _c(
          "archival-table",
          {
            directives: [
              {
                name: "infinite-scroll",
                rawName: "v-infinite-scroll",
                value: _vm.nextPage,
                expression: "nextPage"
              }
            ],
            attrs: {
              "infinite-scroll-disabled": "disableInfiniteScroll",
              "infinite-scroll-distance": "20",
              "infinite-scroll-immediate-check": "false"
            }
          },
          _vm._l(_vm.formattedResults, function(result) {
            return _c("archival-table-row", {
              key: result.runId,
              attrs: {
                "close-status": result.closeStatus,
                "close-time": result.closeTime,
                "cluster-name": _vm.clusterName,
                "domain-name": result.domainName,
                "run-id": result.runId,
                "start-time": result.startTime,
                "workflow-id": result.workflowId,
                "workflow-name": result.workflowName
              }
            })
          }),
          1
        ),
        _vm._v(" "),
        _c("error-message", { attrs: { error: _vm.error } }),
        _vm._v(" "),
        _c("no-results", { attrs: { results: _vm.results } }),
        _vm._v(" "),
        _vm.loading ? _c("loading-spinner") : _vm._e(),
        _vm._v(" "),
        _c(
          "loading-message",
          { attrs: { delay: _vm.loadingMessageDelay, loading: _vm.loading } },
          [
            _c("p", [
              _vm._v(
                "It looks like this request is taking some time to process."
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v("Try reducing CloseTime range to improve search time.")
            ])
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0fb6b6e1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fb6b6e1","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/routes/domain/workflow-archival/advanced.vue
// module id = 1769
// module chunks = 0